/*
    <Style ss:ID="Currency"><NumberFormat ss:Format="Currency"></NumberFormat></Style>
    <Style ss:ID="Date"><NumberFormat ss:Format="Medium Date"></NumberFormat></Style>
*/

export const Cell = `
      <Cell{attributeStyleID}{attributeFormula}{attributeMergeAcross}{attributeMergeDown}{attributeHRef}{attributeIndex}>
        <Data ss:Type="{nameType}">{data}</Data>
      </Cell>
`;

export const Workbook = `
<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
  <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">
    <Author>SIM T2B</Author>
    <Created>{created}</Created>
  </DocumentProperties>
  <Styles>
    {moreStyle}
  </Styles>
  {worksheets}
</Workbook>
`;

export const Worksheet = `
  <Worksheet ss:Name="{nameWS}">
    <Table {attStyleTable}>
      {columns}
      {rows}
    </Table>
  </Worksheet>
`;

export const Style = `    <Style ss:ID="{randid}">{elements}</Style>\n`;